function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.6 0H35.9C35.1 0 34.4 -2.38419e-07 33.6 1.2L32.3 3H3.1C1.4 3 0 4.6 0 6.3V45.6C0 47.3 1.4 49 3.1 49H58.9C60.6 49 62 47.3 62 45.6V15.2V6.4V1.2C62 0.5 61.4 0 60.6 0Z",
  fill: "#C18205"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M60.7 40.4C61.5 39.8 62 38.9 62 37.9V15.2V6.4V1.2C62 0.5 61.4 0 60.6 0H35.9C35.1 0 34.4 -2.38419e-07 33.6 1.2L32.3 3H3.1C1.5 3 0.2 4.3 0 5.8L60.7 40.4Z",
  fill: "#AA6E04"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.1001 7L60.7001 40.2C61.5001 39.6 62.0001 38.9 62.0001 37.9V15.2V9.6L58.2001 7H2.1001Z",
  fill: "#915A02"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M57 7H5V45H57V7Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M57 7H32V45H57V7Z",
  fill: "#EFEFEF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M62 47C62 48.7 60.6 50 58.9 50H3.1C1.4 50 0 48.7 0 47L1 15.3C1 13.6 2.4 12 4.1 12H58C59.7 12 61.1 13.6 61.1 15.3L62 47Z",
  fill: "#FFB000"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M61.6 48.4998L1.1 14.2998C1 14.6998 1 15.0998 1 15.4998L0 46.9998C0 48.6998 1.4 49.9998 3.1 49.9998H58.9C60 49.9998 61 49.3998 61.6 48.4998Z",
  fill: "#FFC200"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M49 27H13C12.2 27 11.5 26.3 11.5 25.5C11.5 24.7 12.2 24 13 24H49C49.8 24 50.5 24.7 50.5 25.5C50.5 26.3 49.8 27 49 27Z",
  fill: "#FFB000"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M49 35H13C12.2 35 11.5 34.3 11.5 33.5C11.5 32.7 12.2 32 13 32H49C49.8 32 50.5 32.7 50.5 33.5C50.5 34.3 49.8 35 49 35Z",
  fill: "#FFB000"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M39.8 43H13C12.2 43 11.5 42.3 11.5 41.5C11.5 40.7 12.2 40 13 40H39.9C40.7 40 41.4 40.7 41.4 41.5C41.3 42.3 40.6 43 39.8 43Z",
  fill: "#FFB000"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M49 25H13C12.2 25 11.5 24.3 11.5 23.5C11.5 22.7 12.2 22 13 22H49C49.8 22 50.5 22.7 50.5 23.5C50.5 24.3 49.8 25 49 25Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M49 33H13C12.2 33 11.5 32.3 11.5 31.5C11.5 30.7 12.2 30 13 30H49C49.8 30 50.5 30.7 50.5 31.5C50.5 32.3 49.8 33 49 33Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M39.8 41H13C12.2 41 11.5 40.3 11.5 39.5C11.5 38.7 12.2 38 13 38H39.9C40.7 38 41.4 38.7 41.4 39.5C41.3 40.3 40.6 41 39.8 41Z",
  fill: "white"
});

var SvgFolder = function SvgFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 50,
    viewBox: "0 0 62 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder.c0c1f1b6.svg";
export { ForwardRef as ReactComponent };